import request from '@/utils/request'

// 组织架构树形结构查询
export function getDepartmentTree(data) {
  return request({
    url: '/common/getDepartmentTree',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 上传图片
export function uploadFiles(data, headers, onUploadProgress) {
  return request({
    url: '/externalApplication/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    onUploadProgress
  })
}
// 组织架构树形结构查询
export function getUserDepartmentTree(data) {
  return request({
    url: '/common/getUserDepartmentTree',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取组织下员工列表
export function getOrgList(data) {
  return request({
    url: `/userJobDepartment/getPageUsersInDepartment`,
    method: 'post',
    data
  })
}

// 搜索获取员工
export function getUserList(data) {
  return request({
    url: `/user/getNoDeptUserList`,
    method: 'post',
    data
  })
}

